const rokkContent = [
    "All your favourite bands, every imaginable subgenre, tailored recommendations and perfect playlists",
    "More € per stream for the bands/artists you listen to*",
    "Direct Artist Support - ROKK pays up to 10% per user per month to your favourite band*",
    "High quality audio and offline streaming",
    "Listen to all other styles of music and artists as well. Our focus is Rock & Metal, but you can listen to anything you want!",
    "With an easy import function for your favourite playlists from other services"
]

export { rokkContent }